module.exports = __webpack_public_path__ + "static/media/petal2.9ea3d830.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/spinners/petal2.svg
 ** module id = 524
 ** module chunks = 44
 **/